export function getRoutes(projectName) {
  return [
    {
      path: "/",
      redirect: "/items", // TODO: change
      meta: { title: projectName },
      component: () => import("shared/layout/Base"),
      children: [
        /* OFFERS */
        {
          path: "/offers",
          meta: { title: projectName + " | Купоны и акции" },
          component: () => import("shared/views/offers/OffersIndex.vue"),
          children: [
            /* COUPONS */
            {
              path: "/offers/coupons",
              meta: { title: projectName + " | Купоны" },
              component: () => import("shared/views/offers/coupons/CouponIndex.vue"),
            },
            /* DISCOUNTS */
            {
              path: "/offers/discounts",
              meta: { title: projectName + " | Скидки" },
              component: () => import("shared/views/offers/discounts/DiscountIndex.vue"),
            },
          ],
        },
        {
          path: "/offers/coupons/create",
          meta: { title: projectName + " | Создание купона" },
          component: () => import("shared/views/offers/coupons/CouponEdit.vue"),
        },
        {
          path: "/offers/coupon/:couponId/edit",
          meta: { title: projectName + " | Редактирование купона" },
          component: () => import("shared/views/offers/coupons/CouponEdit.vue"),
        },
        {
          path: "/offers/discount/:discountId/edit",
          meta: { title: projectName + " | Редактирование скидки" },
          component: () => import("shared/views/offers/discounts/DiscountEdit.vue"),
        },
        /* ORDERS */
        {
          path: "/orders",
          meta: { title: projectName + " | Заказы" },
          component: () => import("shared/views/orders/OrderIndex.vue"),
        },
        {
          path: "/order/:orderId/view",
          meta: { title: projectName + " | Просмотр заказа" },
          component: () => import("shared/views/orders/OrderView.vue"),
        },
        {
          path: "/statistics",
          meta: { title: projectName + " | Статистика" },
          component: () => import("shared/views/statistics/StatisticsIndex.vue"),
        },
        {
          path: "/manage/users",
          meta: { title: projectName + " | Пользователи" },
          component: () => import("shared/views/user/UserIndex.vue"),
        },
        {
          path: "/manage/user/:userId/edit",
          meta: { title: projectName + " | Пользователи" },
          component: () => import("shared/views/user/UserEdit.vue"),
        },
        {
          path: "/manage/payouts",
          meta: { title: projectName + " | Вывод средств" },
          component: () => import("shared/views/payout/PayoutIndex.vue"),
        },
        {
          path: "/manage/payout/:payoutId/view",
          meta: { title: projectName + " | Вывод средств" },
          component: () => import("shared/views/payout/PayoutView.vue"),
        },
        {
          path: "/manage/invoices",
          meta: { title: projectName + " | Счета пользователей" },
          component: () => import("shared/views/invoices/Index.vue"),
        },
        {
          path: "/manage/accounting",
          meta: { title: projectName + " | Бух. учёт" },
          component: () => import("shared/views/invoices/Accounting.vue"),
        },
        {
          path: "/manage/alerts",
          meta: { title: projectName + " | Уведомления пользователям" },
          component: () => import("shared/views/alerts/AlertIndex.vue"),
        },
        {
          path: "/manage/alert/:alertId/edit",
          meta: { title: projectName + " | Редактирование уведомления" },
          component: () => import("shared/views/alerts/AlertEdit.vue"),
        },
        {
          path: "/account/finance",
          meta: { title: projectName + " | Финансы" },
          component: () => import("shared/views/finance/FinanceView.vue"),
        },
        /* {
          path: "/account/finance/payout_methods",
          meta: { title: projectName + " | Способы вывода средств" },
          component: () => import("shared/views/finance/FinancePayoutMethods.vue"),
        }, */
        {
          path: "/account/profile",
          meta: { title: projectName + " | Редактирование профиля" },
          component: () => import("shared/views/profile/ProfileEdit.vue"),
        },
        {
          path: "/callcenter/clients",
          meta: { title: projectName + " | КЦ | Клиенты" },
          component: () => import("shared/views/callcenter/clients/ClientIndex.vue"),
        },
        {
          path: "/callcenter/client/:clientId/edit",
          meta: { title: projectName + " | КЦ | Редактирование клиента" },
          component: () => import("shared/views/callcenter/clients/ClientEdit.vue"),
        },
        {
          path: "/callcenter/orders",
          meta: { title: projectName + " | КЦ | Заказы" },
          component: () => import("shared/views/callcenter/orders/OrderIndex.vue"),
        },
        {
          path: "/callcenter/order/:orderId/edit",
          meta: { title: projectName + " | КЦ | Редактирование заказа" },
          component: () => import("shared/views/callcenter/orders/OrderEdit.vue"),
        },
        {
          path: "/callcenter/order/:orderId/more",
          meta: { title: projectName + " | КЦ | Информация по заказу" },
          component: () => import("shared/views/callcenter/orders/OrderMore.vue"),
        },

        //#region Courses
        {
          path: "/courses",
          meta: { title: projectName + " | Курсы" },
          component: () => import("shared/views/course/CourseIndex.vue"),
        },
        {
          path: "/course",
          meta: { title: projectName + " | Курсы" },
          component: () => import("shared/views/course/CourseEdit.vue"),
          children: [
            {
              path: "/course/:courseId/lessons",
              meta: { title: projectName + " | Курс - Разделы и уроки" },
              component: () => import("shared/views/course/tabs/Lessons.vue"),
            },
            {
              path: "/course/:courseId/lesson/:lessonId/edit",
              meta: { title: projectName + " | Курс - Редактирование урока" },
              component: () => import("shared/views/course/tabs/LessonEdit.vue"),
            },
            {
              path: "/course/:courseId/students",
              meta: { title: projectName + " | Курс - Ученики" },
              component: () => import("shared/views/course/tabs/Students.vue"),
            },
            {
              path: "/course/:courseId/student/:clientId",
              meta: { title: projectName + " | Курс - Просмотр ученика" },
              component: () => import("shared/views/course/tabs/StudentView.vue"),
              children: [
                {
                  path: "/course/:courseId/student/:clientId/comments",
                  meta: { title: projectName + " | Курс - Комментарии ученика" },
                  component: () => import("shared/widgets/lesson/studentViewTabs/Comments.vue"),
                },
              ],
            },
            {
              path: "/course/:courseId/groups",
              meta: { title: projectName + " | Курс - Группы" },
              component: () => import("shared/views/course/tabs/Groups.vue"),
            },
            {
              path: "/course/:courseId/comments",
              meta: { title: projectName + " | Курс - Комментарии" },
              component: () => import("shared/widgets/course/Comments.vue"),
            },
            {
              path: "/course/:courseId/tests",
              meta: { title: projectName + " | Курс - Тесты" },
              component: () => import("shared/views/course/tabs/Tests.vue"),
            },
            {
              path: "/course/:courseId/tests/try/:tryId/view",
              meta: { title: projectName + " | Курс - Тест ученика" },
              component: () => import("shared/widgets/lesson/test/TestTry.vue"),
            },
            {
              path: "/course/:courseId/tests/:testId/stats",
              meta: { title: projectName + " | Курс - Статистика теста" },
              component: () => import("shared/widgets/lesson/test/TestStats.vue"),
            },
            {
              path: "/course/:courseId/surveys",
              meta: { title: projectName + " | Курс - Опросы" },
              component: () => import("shared/views/course/tabs/Surveys.vue"),
            },
            {
              path: "/course/:courseId/surveys/vote/:voteId/view",
              meta: { title: projectName + " | Курс - Результат опроса ученика" },
              component: () => import("shared/widgets/lesson/survey/ClientVote.vue"),
            },
            {
              path: "/course/:courseId/surveys/:surveyId/stats",
              meta: { title: projectName + " | Курс - Статистика опроса" },
              component: () => import("shared/widgets/lesson/survey/SurveyStats.vue"),
            },
            {
              path: "/course/:courseId/homework",
              meta: { title: projectName + " | Курс - Домашние задания" },
              component: () => import("shared/views/course/tabs/Homework.vue"),
            },
            {
              path: "/course/:courseId/homework/:homeworkId/client/:clientId/view",
              meta: { title: projectName + " | Курс - Результат домашнего задания ученика" },
              component: () => import("shared/widgets/lesson/homework/HomeworkTry.vue"),
            },
            {
              path: "/course/:courseId/settings",
              meta: { title: projectName + " | Курс - Настройки" },
              component: () => import("shared/views/course/tabs/Settings.vue"),
            },
            {
              path: "/course/:courseId/sellsettings",
              meta: { title: projectName + " | Курс - Настройки продаж" },
              component: () => import("shared/views/course/tabs/SellSettings.vue"),
            },
          ],
        },
        //#endregion
        //#region Lesson
        {
          path: "/lesson",
          meta: { title: projectName + " | Урок - Редактирование" },
          component: () => import("shared/views/lesson/LessonIndex.vue"),
          children: [
            {
              path: "/lesson/:lessonId/edit",
              meta: { title: projectName + " | Урок - Редактирование" },
              component: () => import("shared/views/lesson/tabs/Edit.vue"),
            },
            {
              path: "/lesson/:lessonId/students",
              meta: { title: projectName + " | Урок - Ученики" },
              component: () => import("shared/views/course/tabs/Students.vue"),
            },
            {
              path: "/lesson/:lessonId/student/:clientId",
              meta: { title: projectName + " | Урок - Просмотр ученика" },
              component: () => import("shared/views/course/tabs/StudentView.vue"),
              children: [
                {
                  path: "/lesson/:lessonId/student/:clientId/comments",
                  meta: { title: projectName + " | Урок - Комментарии ученика" },
                  component: () => import("shared/widgets/lesson/studentViewTabs/Comments.vue"),
                },
              ],
            },
            {
              path: "/lesson/:lessonId/comments",
              meta: { title: projectName + " | Урок - Комментарии" },
              component: () => import("shared/widgets/course/Comments.vue"),
            },
            {
              path: "/lesson/:lessonId/tests",
              meta: { title: projectName + " | Урок - Тесты" },
              component: () => import("shared/views/course/tabs/Tests.vue"),
            },
            {
              path: "/lesson/:lessonId/tests/try/:tryId/view",
              meta: { title: projectName + " | Урок - Тест ученика" },
              component: () => import("shared/widgets/lesson/test/TestTry.vue"),
            },
            {
              path: "/lesson/:lessonId/tests/:testId/stats",
              meta: { title: projectName + " | Урок - Статистика теста" },
              component: () => import("shared/widgets/lesson/test/TestStats.vue"),
            },
            {
              path: "/lesson/:lessonId/surveys",
              meta: { title: projectName + " | Урок - Опросы" },
              component: () => import("shared/views/course/tabs/Surveys.vue"),
            },
            {
              path: "/lesson/:lessonId/surveys/vote/:voteId/view",
              meta: { title: projectName + " | Урок - Результат опроса ученика" },
              component: () => import("shared/widgets/lesson/survey/ClientVote.vue"),
            },
            {
              path: "/lesson/:lessonId/surveys/:surveyId/stats",
              meta: { title: projectName + " | Урок - Статистика опроса" },
              component: () => import("shared/widgets/lesson/survey/SurveyStats.vue"),
            },
            {
              path: "/lesson/:lessonId/homework",
              meta: { title: projectName + " | Урок - Домашние задания" },
              component: () => import("shared/views/course/tabs/Homework.vue"),
            },
            {
              path: "/lesson/:lessonId/homework/try/:tryId/view",
              meta: { title: projectName + " | Урок - Результат домашнего задания ученика" },
              component: () => import("shared/widgets/lesson/homework/HomeworkTry.vue"),
            },
            {
              path: "/lesson/:lessonId/settings",
              meta: { title: projectName + " | Урок - Настройки" },
              component: () => import("shared/views/course/tabs/Settings.vue"),
            },
            {
              path: "/lesson/:lessonId/sellsettings",
              meta: { title: projectName + " | Урок - Настройки продаж" },
              component: () => import("shared/views/course/tabs/SellSettings.vue"),
            },
          ],
        },
        //#endregion
        {
          path: "/clients",
          meta: { title: projectName + " | Клиенты" },
          component: () => import("shared/views/clients/ClientIndex.vue"),
        },
        {
          path: "/client/:clientId/view",
          meta: { title: projectName + " | Информация о клиенте" },
          component: () => import("shared/views/clients/ClientMore.vue"),
        },
        //#region TICKETS
        {
          path: "/tickets",
          meta: { title: projectName + " | Обращения в техподдержку" },
          component: () => import("shared/views/ticket/All.vue"),
        },
        {
          path: "/ticket/:ticketId/view",
          meta: { title: projectName + " | Обращение в техподдержку" },
          component: () => import("shared/views/ticket/One.vue"),
        },
        //#endregion
        //#region TICKETS
        {
          path: "/customer-questions",
          meta: { title: projectName + " | Вопросы покупателей" },
          component: () => import("shared/views/customer_questions/All.vue"),
        },
        {
          path: "/customer-question/:customerQuestionId/view",
          meta: { title: projectName + " | Вопрос покупателя" },
          component: () => import("shared/views/customer_questions/One.vue"),
        },
        //#endregion
      ],
    },
    {
      path: "/auth",
      component: () => import("shared/layout/Auth"),
      children: [
        {
          path: "/auth/register",
          meta: { title: projectName + " | Регистрация" },
          component: () => import("shared/views/auth/Register"),
        },
        {
          path: "/auth/login",
          meta: { title: projectName + " | Вход" },
          component: () => import("shared/views/auth/Login.vue"),
          props: (route) => ({
            backurl: route.query.backurl,
          }),
        },
        {
          path: "/auth/logout",
          meta: { title: projectName + " | Выход" },
          component: () => import("shared/views/auth/Logout"),
        },
        {
          path: "/auth/login-by-token",
          meta: { title: projectName + " | Вход по ключу" },
          component: () => import("shared/views/auth/LoginByToken.vue"),
          props: (route) => ({
            token: route.query.hash,
          }),
        },
        {
          path: "/auth/forgot-password",
          meta: { title: projectName + " | Восстановление пароля" },
          component: () => import("shared/views/auth/ForgotPassword"),
        },
        {
          path: "/auth/password-recovery",
          meta: { title: projectName + " | Восстановление пароля" },
          component: () => import("shared/views/auth/PasswordRecovery.vue"),
          props: (route) => ({
            hash: route.query.hash,
          }),
        },
      ],
    },
    {
      path: "*",
      meta: { title: projectName + " | Ошибка" },
      redirect: "/error/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/error",
      redirect: "/error/404",
      component: () => import("shared/views/errors/Error.vue"),
      children: [
        {
          path: "/error/404",
          meta: { title: projectName + " | Ошибка" },
          component: () => import("shared/views/errors/404.vue"),
        },
      ],
    },
  ];
}
